import * as React from "react";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { StoreRating } from "./StoreRating.js";
const StoreRatingContainer = ({ store, ...rest }) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const { isStoreRatingsEnabled } = useFeatureToggles();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.component.storeRating.title"),
      rating: getFormattedLabel("stores.component.storeRating.rating", {
        labelData: {
          rating: store.rating?.value ?? ""
        }
      }),
      ratingCount: getFormattedLabel("stores.component.storeRating.ratingCount", {
        labelData: {
          count: store.rating?.count ?? ""
        }
      }),
      description: getLabel("stores.component.storeRating.description"),
      review: getLabel("stores.component.storeRating.review")
    }),
    [getLabel, getFormattedLabel, store]
  );
  const urls = React.useMemo(
    () => ({
      review: store.googlePlaceReviewUrl?.length ? store.googlePlaceReviewUrl : void 0
    }),
    [store]
  );
  const onClickReview = React.useCallback(() => {
    console.log(store);
  }, [store]);
  if (!isStoreRatingsEnabled || !store.rating) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StoreRating,
    {
      ...rest,
      labels,
      rating: store.rating.value,
      urls,
      onClickReview
    }
  );
};
export {
  StoreRatingContainer,
  StoreRatingContainer as default
};
//# sourceMappingURL=StoreRatingContainer.js.map
